<svg
    width="311"
    height="187"
    viewBox="0 0 311 187"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>

    <g
        [x]="70"
        [y]="-45"
        app-roof-box></g>

    <g
        [x]="-70"
        [y]="40"
        app-roof-box></g>

    <g
        [x]="100"
        [y]="-30"
        app-roof-vent></g>

    <g
        [x]="50"
        [y]="0"
        app-roof-vent></g>
</svg>
